import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../components/content/axiosConfig';
import { queryKeys } from './queryKeys';

export function useDashboardOwner(fisherId, options = {}) {
  return useQuery({
    queryKey: queryKeys.dashboardOwner(fisherId),
    queryFn: async () => {
      const response = await axiosInstance.get(`api/DashBoard/GetReport/${fisherId}`);
      return response.data ?? {};
    },
    enabled: fisherId != null && fisherId !== '',
    staleTime: 2 * 60_000,
    ...options,
  });
}
